export const ONBOARDING_FIELDS = {
  EMAIL: "email",
  COUNTRY: "country",
  SPECIALITY: "speciality",
};

export const getAllOnboardingFields = () => {
  const onboardingFields = [];

  for (let key in ONBOARDING_FIELDS) {
    onboardingFields.push(ONBOARDING_FIELDS[key]);
  }
  return onboardingFields;
};

export const DEFAULT_ONBOARDING_MESSAGE =
  "Can you tell us more about yourself? We like to be friends with every doctor on Casemasters.";



// WEBPACK FOOTER //
// ./src/components/OnBoardingDimmer/constants.js